import { render, staticRenderFns } from "./VProcessRating.vue?vue&type=template&id=c4f6e8b4&"
import script from "./VProcessRating.vue?vue&type=script&lang=js&"
export * from "./VProcessRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports